/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Loading_Token_DataInputs */



/**
* | output |
* | --- |
* | "Loading token data..." |
*
* @param {Dashboard_Loading_Token_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_loading_token_data = /** @type {((inputs?: Dashboard_Loading_Token_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Loading_Token_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lade Token-Daten...")
	return /** @type {LocalizedString} */ ("Loading token data...")
});